import Item1 from '../assets/Memory/SVG/1.svg';
import Item2 from '../assets/Memory/SVG/2.svg';
import Item3 from '../assets/Memory/SVG/3.svg';
import Item4 from '../assets/Memory/SVG/4.svg';
import Item5 from '../assets/Memory/SVG/5.svg';
import Item6 from '../assets/Memory/SVG/6.svg';
import Item7 from '../assets/Memory/SVG/7.svg';
import Item8 from '../assets/Memory/SVG/8.svg';

export const memoryImages = [
	{
		id:1,
		frontImg: Item1,
	},
	{
		id:2,
		frontImg: Item2
	},
	{
		id:3,
		frontImg: Item3
	},
	{
		id:4,
		frontImg: Item4
	},
	{
		id:5,
		frontImg: Item5
	},
	{
		id:6,
		frontImg: Item6
	},
	{
		id:7,
		frontImg: Item7
	},
	{
		id:8,
		frontImg: Item8
	}
];